import { CSSProperties } from 'react';
import { css } from 'styled-components';

/**
 * CenterBlock helper used to create a `position` block in center of it's parent
 * @example
 * const Style = styled.div`
 *      ${centerBlock()} // absolute block
 *      ${centerBlock('fixed')} // fixed block
 *      ${centerBlock('fixed', 'rotate(90deb)')} // fixed & rotated block
 * `
 *
 * @param position {CSSProperties['position']} CSS position value
 * @param transform {string} Additional transform props
 * @returns {any[]}
 */
export const centerBlock = (position: CSSProperties['position'] = 'absolute', transform = '') => css`
    & {
        position: ${position};
        top: 50%;
        left: 50%;
        transform: translate3d(-50%, -50%, 0) ${transform ? ` ${transform}` : ''};
    }
`;
